import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoDblClickDirective } from './no-dbl-click.directive';
import { AutofocusDirective } from './autofocus.directive';
import FocusControlDirective from './focuscontrol.directive';
import { DebounceClickDirective } from './debounceClick.directive';
import { DebounceUpKeyDirective } from './debounceUpKey.directive';

@NgModule({
  declarations: [NoDblClickDirective, DebounceClickDirective,
    AutofocusDirective, FocusControlDirective, DebounceUpKeyDirective],
  imports: [
    CommonModule
  ],
  exports: [
    NoDblClickDirective, DebounceClickDirective,
    AutofocusDirective, FocusControlDirective, DebounceUpKeyDirective
  ]
})
export class DirectivesModule { }
